import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import Tooltip from '../../tooltip/Tooltip.vue';
import { HelpItems, UserItems } from './MenuBar.vue';
import vuetify from '../../../service/useVuetify';
import TooltippedText from '../../tooltip/TooltippedText/TooltippedText.vue';
import LoadingSpinner from '../../loaders/LoadingSpinner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavFooter',
  props: {
    mini: { type: Boolean },
    helpCenter: null,
    profileTooltip: null,
    helpItems: null,
    userItems: null,
    userName: null,
    email: null
  },
  emits: ["onusershiftdblclick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onusershiftdblclick'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  mini: boolean;
  helpCenter?: string;
  profileTooltip: string;
  helpItems: HelpItems;
  userItems: UserItems;
  userName: string;
  email: string;
};





const helpToggled = ref(false);

const helpMenuNudgeRight = computed(() => {
  return vuetify.value.breakpoint.mdAndDown || props.mini ? 35 : vuetify.value.breakpoint.name === 'xl' ? 230 : 196;
});

const isAnyUserItemActive = computed(() => props.userItems.some((item) => item.active));

return { __sfc: true,props, emit, helpToggled, helpMenuNudgeRight, isAnyUserItemActive, Tooltip, vuetify, TooltippedText, LoadingSpinner }
}

})